import {
  CHANGE_ACCOUNT,
  LOAD_INTEGRATIONS,
  LOAD_INTEGRATIONS_SUCCESS,
  SAVE_INTEGRATION,
  SAVE_INTEGRATION_PENDING,
  SAVE_INTEGRATION_SUCCESS,
  CLEAR_MESSAGE,
} from "./types";

import axios from "../../lib/axios";
import config from "../../config/app-config.json";

export const changeAccountId = (value: any) => {
  return (dispatch: any) => {
    dispatch({
      type: CHANGE_ACCOUNT,
      payload: value,
    });
  };
};

export const loadIntegrations = () => {
  return (dispatch: any) => {
    dispatch({
      type: LOAD_INTEGRATIONS,
      payload: null,
    });

    axios
      .get(`${config.serviceUrl}/integrations/`)
      .then((response: any) => {
        dispatch({
          type: LOAD_INTEGRATIONS_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((err: any) => {
        console.error("loadIntegrations failed:", err);
      });
  };
};

/**
 * CALLBACK mode:
 * payload: { code, state }
 */
export const saveIntegration = (integration: any, history?: any) => {
  return (dispatch: any) => {
    dispatch({
      type: SAVE_INTEGRATION,
      payload: null,
    });

    axios
      .post(`${config.serviceUrl}/integrations`, integration)
      .then((response: any) => {
        const data = response && response.data ? response.data.data : null;

        var accounts = data && data.accounts && Array.isArray(data.accounts) ? data.accounts : null;
        
        if (accounts && accounts.length > 0) {
          dispatch({
            type: SAVE_INTEGRATION_PENDING,
            payload: {
              accounts: accounts,
              facebookState: data.state,
              integrationId: data.integrationId || null,
            },
          });
        } else {
          // IMPORTANT: if no accounts came back, treat as an error
          // (this happens when ads_management is missing or reviewer account has no access)
          dispatch({
            type: SAVE_INTEGRATION_SUCCESS,
            payload: {
              error: true,
              message:
                "Facebook connected, but we could not load any Ad Accounts. This usually means the required permissions were not granted (ads_management) or the Facebook user has no Ad Account access. Please retry and approve permissions.",
            },
          });
        }
      })
      .catch((err: any) => {
        var msg = "Integration failed";
        var code = "";
        var required: any[] = [];
        var granted: any[] = [];
      
        if (err && err.response && err.response.data) {
          var d = err.response.data;
      
          if (d && d.error) {
            if (d.error.message) msg = String(d.error.message);
            if (d.error.code) code = String(d.error.code);
      
            if (d.error.required_permissions && Array.isArray(d.error.required_permissions)) {
              required = d.error.required_permissions;
            }
            if (d.error.granted_permissions && Array.isArray(d.error.granted_permissions)) {
              granted = d.error.granted_permissions;
            }
          } else if (d && d.message) {
            msg = String(d.message);
          }
        } else if (err && err.message) {
          msg = String(err.message);
        }
      
        // Build a more helpful message if missing permissions
        if (code === "MISSING_FACEBOOK_PERMISSION") {
          var reqText = required.length ? required.join(", ") : "ads_management";
          var grantText = granted.length ? granted.join(", ") : "(none)";
          msg =
            "Facebook connected, but required permissions were not granted.\n" +
            "Required: " + reqText + "\n" +
            "Granted: " + grantText + "\n" +
            "Please retry and approve the requested permissions.";
        }
      
        dispatch({
          type: SAVE_INTEGRATION_SUCCESS,
          payload: {
            error: true,
            message: msg,
            fb_error_code: code,
            fb_required_permissions: required,
            fb_granted_permissions: granted
          },
        });
      });
  };
};

/**
 * FINALIZE mode:
 * payload: { accountId, state }
 */
export const reSaveIntegration = (payload: any) => {
  return (dispatch: any) => {
    dispatch({
      type: SAVE_INTEGRATION,
      payload: null,
    });

    axios
      .post(`${config.serviceUrl}/integrations`, payload)
      .then((response: any) => {
        dispatch({
          type: SAVE_INTEGRATION_SUCCESS,
          payload: response,
        });
      })
      .catch((err: any) => {
        let msg = "Integration finalize failed";

        if (err && err.response && err.response.data) {
          const d = err.response.data;
          if (d.error && d.error.message) msg = d.error.message;
          else if (d.message) msg = d.message;
        } else if (err && err.message) {
          msg = err.message;
        }

        dispatch({
          type: SAVE_INTEGRATION_SUCCESS,
          payload: { error: true, message: msg },
        });
      });
  };
};

export const clearIntegrationMessage = () => {
  return (dispatch: any) => {
    dispatch({
      type: CLEAR_MESSAGE,
      payload: null,
    });
  };
};
